import styled from 'styled-components';

export const ContainerStyled = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  justify-content: space-around;
  align-items: center;
  width: 100%;
`;

export const ContainerInterno = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  margin-left: 10px;
`;

export const ContainerInternoInput = styled.div`
  z-index: 0;
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  margin-left: 10px;
`;

export const style = {
  title: {
    fontSize: '30px',
  },
  titleContent: {
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
  header: {
    display: 'flex',
  },
  gridStyle: {
    padding: '5px',
  },
  contentMargin: {
    padding: '5px',
    margin: '5px',
    minHeight: '72vh',
    paddingBottom: '5px',
    background: '#ffffff',
  },
  optionsContent: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  cardStyle: {
    padding: '10px',
    maxHeight: '70vh',
    overflow: 'auto',
    height: '70vh',
    borderRadius: '5px',
  },
  cardList: {
    maxHeight: '55vh',
    overflow: 'auto',
    height: '55vh',
    borderRadius: '5px',
  },
  cardContent: {
    padding: '5px',
    maxHeight: '56vh',
    overflow: 'auto',
    borderRadius: '5px',
  },
  chatBotButton: {
    position: 'fixed',
    width: '40px',
    height: '40px',
    bottom: '15px',
    right: '20px',
    backgroundColor: '#13293d',
    color: '#FFF',
    orderRadius: '50px',
    textAlign: 'center',
    fontSize: '30px',
    boxShadow: '1px 1px 2px #888',
    zIndex: 1000,
  },
  box: {
    marginBottom: 10,
  },
  notFoundBox: {
    width: '99vw',
    height: '85vh',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  divBox: {
    width: '20%',
    display: 'flex',
    flexDirection: 'column',
  },
};
